import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { OvhNickhandleService } from '../../services/ovh-nickhandle.service';


@Component({
  selector: 'backups',
  templateUrl: './backups.component.html',
  styleUrls: ['./backups.component.css']
})
export class BackupsComponent implements OnInit  {
  modalRef: BsModalRef;
  
  nickhandle : any;
  @Input() filter = 'ALL';
  
  constructor(
  	private readonly modalService: BsModalService,
  	private readonly router: Router,
  	private readonly route: ActivatedRoute,
  	private readonly ovhNickhandle: OvhNickhandleService) {
  }
  
  ngOnInit() {
  	this.route.paramMap.subscribe((params: ParamMap) => {
        console.log(params.get('nickhandle'));
        this.nickhandle = this.ovhNickhandle.getNickhandle(params.get('nickhandle'));
      }
    );
  }
  
}
